import { BlockSelectField } from '@common/components/FormElements/BlockSelectField';
import moment from 'moment';
import { Controller, FieldPath, useFormContext } from 'react-hook-form';
import { RoomExtraOption } from 'shared-types/Room';
import { RoomRateFormValues } from '../../../../RoomRateFormV2.schema';

type PerDateTimeOption = RoomExtraOption & { startDate?: string; time?: string };

const optionsForPerDateTime = (options: PerDateTimeOption[]) =>
  options.map((option, index) => ({
    label: `${moment(option.startDate).format('MMM DD')} - ${option?.time?.substr(0, 5)}`,
    value: index,
  }));

type SelectOption = { label: string; value: number };

export const PerDateTimeV2 = ({ id, options }: { id: number; options: RoomExtraOption[] }) => {
  const { control } = useFormContext<RoomRateFormValues>();
  const opts = optionsForPerDateTime(options as PerDateTimeOption[]);

  return (
    <Controller
      control={control}
      name={`extras.${id}.option` as FieldPath<RoomRateFormValues>}
      render={({ field: { value, onChange } }) => (
        <BlockSelectField
          options={opts}
          value={opts.find((o) => o.value === value) ?? null}
          onChange={(selected: SelectOption) => onChange(selected?.value ?? null)}
        />
      )}
    />
  );
};
